import React from 'react';

//-- Utils
import * as staticsTool from './../../utils/url/staticUrl';

/**
 * Container used for displaying a list of product's   
 */
const ProductContainer = (props) => {
    const bgProduct = {'background': `url('${staticsTool.getFirstAsset('media/km/xlarge/'+props.img)}') 50% 50% / cover no-repeat`};
    const costColor = (props.productIndex % 4) + 1;
    return <div 
        className={props.className.join(" ")} 
        onClick={props.onClick} 
        data-index={props.productIndex} >
        <div 
            className="product-container-main-picture"
            style={bgProduct}>
            <div className={`cost-of-product color-${costColor}`}>
                <span>{props.price}</span><span>points</span>
            </div>
        </div>
        <div className="product-container-short-description">
            <h3>{props.title}</h3>
        </div>
    </div>;
}

export default ProductContainer;


// WEBPACK FOOTER //
// ./src/containers/Product/ProductContainer.js